module.exports = __webpack_public_path__ + "img/postepay.5d24a170.png";